import { Box, Chip } from "@mui/material";

export const ChipSoftInf = () => {
  return (
    <Box sx={{ display: "flex", gap: 1, alignItems: "center" }} mb={2}>
      <Chip
        sx={{
          backgroundColor: "rgba(255, 255, 255, 0.8)",
          color: "black",
          fontSize: "9px",
          border: "1px solid",
        }}
        label="Unausgefüllt"
        size="small"
      />
    </Box>
  );
};
